import uiActions from '../actions/UIActions';
import clientEventType from '../constants/ClientEventType';
import hardwareConstants from '../constants/HardwareConstants';
import storeManager from '../store/StoreManager';
import sessionReader from '../store/readHelpers/SessionReader';
import marketplacePropertiesService from './MarketplacePropertiesService';
import navigationService from './NavigationService';
import apiService from './api/ApiService';
import { t } from './i18nService';

const hardwareDetectionService = {
    isAdditionalScreenDetectionRequired() {
        return sessionReader.isContextExam() && sessionReader.userHasLockDown() && sessionReader.userHasChromeKiosk()
            && marketplacePropertiesService.isChromebookDisplayDetectionEnabled();
    },

    handleAdditionalScreenDetection() {
        console.log('extended screen detected');
        storeManager.dispatch(uiActions.setScreenWasExtended(true));
        const extraInfo = t('hardwareDetection.secondScreen.monitorNotification');
        apiService.notifyClientEvent(clientEventType.ISEB_DEVICE_SECURITY_VIOLATION, extraInfo, false, sessionReader.getAssessmentRunId(true));

        setTimeout(navigationService.exitTest, hardwareConstants.exitTimeoutOnSecondDisplayDetected * 1000);
    },

    handleScreenChange(data) {
        if (data.target.isExtended) {
            this.handleAdditionalScreenDetection();
        }
    },

    addAdditionalScreenDetector() {
        if (window?.screen?.isExtended === undefined) {
            console.log('extended screen detector is not supported');
            return;
        }

        if (window.screen.isExtended) {
            this.handleAdditionalScreenDetection();
        } else {
            const screenChangeHandler = this.handleScreenChange.bind(hardwareDetectionService);
            window.screen.addEventListener('change', screenChangeHandler, { once: true });
            console.log('extended screen detector has been added');
        }
    },

};

export default hardwareDetectionService;
